import { useMediaQuery } from './useMediaQuery';

/**
 * Canonical mobile breakpoint for the whole app.
 *
 * Convention (see plan "Mobile / Responsive Support"):
 * - Pure layout changes: CSS `@media (max-width: 768px)` in the component's
 *   own .css file (use this same 768px value).
 * - Behavioral changes (drawer, tab gating, tap semantics, not mounting
 *   desktop-only DOM): `useIsMobile()` in JSX.
 *
 * Width-based on purpose (not pointer:coarse) so Chrome devtools device
 * emulation exercises exactly the same code path as a real phone.
 */
export const MOBILE_QUERY = '(max-width: 768px)';

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

/** True while the device is in portrait orientation (viewer rotate-overlay). */
export const useIsPortrait = () => useMediaQuery('(orientation: portrait)');

/** Touch-first pointer — used ONLY by the viewer gesture adapter, never for layout. */
export const useIsCoarsePointer = () => useMediaQuery('(pointer: coarse)');

export default useIsMobile;
